import { components } from '~/api/OnPremAgentClient/generated-schema'
import { JsonSchema } from '~/types/JsonSchema.interface'
import OnPremAgentAPI from '../OnPremAgentClient/OnPremAgentAPI'

export type GlobalConfig = components['schemas']['GlobalConfig']
export type UpdateGlobalConfigRequest =
  components['schemas']['UpdateGlobalConfigRequest']
export type DefaultSuccessResponse = components['schemas']['DefaultSuccessResponse']

class CloudAPI extends OnPremAgentAPI {
  getConfig = (): Promise<GlobalConfig> => {
    return this.client.GET('/api/global-config/')
  }

  updateConfig = (config: UpdateGlobalConfigRequest): Promise<GlobalConfig> => {
    return this.client.PUT('/api/global-config/', {
      body: config,
    })
  }

  getConfigSchema = async (): Promise<JsonSchema> => {
    const response: Record<string, unknown> = await this.client.GET(
      '/api/global-config/schema',
    )

    return response as unknown as JsonSchema
  }

  verifyCloudConnection = (): Promise<DefaultSuccessResponse> => {
    return this.client.GET('/api/global-config/verify-cloud-connection')
  }
}

export default CloudAPI
